"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@streem/api");
const toolbox_1 = require("@streem/toolbox");
const logger_1 = require("../../util/logger");
class BaseSyncClientCred {
    getWallCreds() {
        (0, toolbox_1.invariant)(this.wallCreds, 'wallCreds must be defined. Make sure to call fetch() first.');
        return this.wallCreds;
    }
    disconnect() {
        this.wallCreds = undefined;
        this.inProgressFetch = undefined;
    }
}
class UserSyncClientCred extends BaseSyncClientCred {
    fetch(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.inProgressFetch === undefined) {
                this.inProgressFetch = this.createUserToken(userId)
                    .then(data => {
                    let wallCredsData;
                    if (data.twilioSync) {
                        wallCredsData = data.twilioSync;
                    }
                    else if (data.streemWall) {
                        wallCredsData = data.streemWall;
                    }
                    (0, toolbox_1.invariant)(wallCredsData === null || wallCredsData === void 0 ? void 0 : wallCredsData.mapName, 'mapName must exist on user token data');
                    (0, toolbox_1.invariant)(wallCredsData === null || wallCredsData === void 0 ? void 0 : wallCredsData.token, 'token must exist on user token data');
                    this.wallCreds = {
                        mapName: wallCredsData.mapName,
                        token: wallCredsData.token,
                        syncService: data.twilioSync ? 'twilio' : 'streem',
                    };
                })
                    .catch(err => {
                    logger_1.logger.error('Error fetching user token.', err);
                    this.wallCreds = undefined;
                })
                    .finally(() => {
                    this.inProgressFetch = undefined;
                });
            }
            yield this.inProgressFetch;
        });
    }
    createUserToken(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            logger_1.logger.info(`Creating new User Token for userId=${userId}`);
            const { userWallCredentials } = yield api_1.StreemAPI.users.createUserTokens(userId.toString());
            (0, toolbox_1.invariant)(userWallCredentials, 'User Wall Credentials must be defined');
            return userWallCredentials;
        });
    }
}
class RoomWallSyncClientCred extends BaseSyncClientCred {
    toMapName(roomSid) {
        return `${roomSid}:wall`;
    }
    fetch(roomId, userId, readOnly) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.inProgressFetch === undefined) {
                this.inProgressFetch = this.createRoomWallToken(roomId, userId, readOnly)
                    .then(data => {
                    this.wallCreds = data;
                })
                    .catch(err => {
                    logger_1.logger.error('Error fetching room wall token.', err);
                    this.wallCreds = undefined;
                })
                    .finally(() => {
                    this.inProgressFetch = undefined;
                });
            }
            yield this.inProgressFetch;
        });
    }
    createRoomWallToken(roomSid, userId, readOnly) {
        return __awaiter(this, void 0, void 0, function* () {
            let wallCredentials;
            let syncService;
            if (readOnly) {
                const credResponse = yield api_1.StreemAPI.rooms.createReadonlyRoomToken(roomSid.toString());
                wallCredentials = credResponse.streemRoomCredentials;
                syncService = 'twilio';
            }
            else {
                (0, toolbox_1.invariant)(userId, 'Expected userId to be defined when creating room wall write token');
                const credResponse = yield api_1.StreemAPI.rooms.createRoomWallCredentials(roomSid.toString(), userId.toString());
                if (credResponse.twilioRoomWallCredentials) {
                    wallCredentials = credResponse.twilioRoomWallCredentials;
                    syncService = 'twilio';
                }
                else if (credResponse.streemRoomWallCredentials) {
                    wallCredentials = credResponse.streemRoomWallCredentials;
                    syncService = 'streem';
                }
            }
            (0, toolbox_1.invariant)(wallCredentials, 'Streem Room Credentials must be defined');
            (0, toolbox_1.invariant)(wallCredentials === null || wallCredentials === void 0 ? void 0 : wallCredentials.roomSid, 'roomSid must exist on room wall token data');
            (0, toolbox_1.invariant)(wallCredentials === null || wallCredentials === void 0 ? void 0 : wallCredentials.token, 'token must exist on room wall token data');
            (0, toolbox_1.invariant)(syncService, 'wallType must be defined');
            return {
                mapName: this.toMapName(wallCredentials.roomSid),
                token: wallCredentials.token,
                dataKey: wallCredentials === null || wallCredentials === void 0 ? void 0 : wallCredentials.dataKey,
                syncService: syncService,
            };
        });
    }
}
class WallTokenUtil {
    constructor() {
        this.userClientCred = new UserSyncClientCred();
        this.roomWallClientCred = new RoomWallSyncClientCred();
    }
}
exports.default = new WallTokenUtil();
//# sourceMappingURL=wall_token_util.js.map